import PetsList from './List';
import PetsForm from './Form';
import VaccinesList from './vaccines/List';
import VaccinesForm from './vaccines/Form';
import ExamsList from './exams/List';
import ExamsForm from './exams/Form';
import BathList from './bath/List';
import BathForm from './bath/Form';
import WeightList from './weight/List';
import WeightForm from './weight/Form';
import ConsultationList from './consultation/List';
import ConsultationForm from './consultation/Form';
import MedicineList from './medicine/List';
import MedicineForm from './medicine/Form';
export default {
    path: 'cadastros',
    redirect: '/cadastros/clientes/:idCliente/pets',
    name: 'Cadastro Pets',
    component: {
        PetsList,
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'clientes/:idCliente/pets',
            name: 'list-pet',
            component: PetsList,
            meta: {
                requiresAuth: true,
                label: 'Listar Pets'
            }
        },
        {
            path: 'clientes/:idCliente/pets/add',
            name: 'new-pet',
            component: PetsForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Pet'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id',
            name: 'edit-pet',
            component: PetsForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Pet'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/vacinas',
            name: 'list-vaccines-pet',
            component: VaccinesList,
            meta: {
                requiresAuth: true,
                label: 'Vacinas'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/vacinas/nova',
            name: 'new-vaccine-pet',
            component: VaccinesForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar vacina'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/vacina/:idVacina',
            name: 'edit-vaccine-pet',
            component: VaccinesForm,
            meta: {
                requiresAuth: true,
                label: 'Editar vacina'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/exames',
            name: 'list-exams-pet',
            component: ExamsList,
            meta: {
                requiresAuth: true,
                label: 'Exames'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/exames/novo',
            name: 'new-exams-pet',
            component: ExamsForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Exame'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/exames/:idExam',
            name: 'edit-exams-pet',
            component: ExamsForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Exame'
            }
        },

        {
            path: 'clientes/:idCliente/pets/:id/banho',
            name: 'list-bath-pet',
            component: BathList,
            meta: {
                requiresAuth: true,
                label: 'Banho'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/banho/novo',
            name: 'new-bath-pet',
            component: BathForm,
            meta: {
                requiresAuth: true,
                label: 'Novo Banho'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/banho/:idBath',
            name: 'edit-bath-pet',
            component: BathForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Banho'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/peso',
            name: 'list-weight-pet',
            component: WeightList,
            meta: {
                requiresAuth: true,
                label: 'Peso'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/peso/novo',
            name: 'new-weight-pet',
            component: WeightForm,
            meta: {
                requiresAuth: true,
                label: 'Atualizar Peso'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/peso/:idWeight',
            name: 'edit-weight-pet',
            component: WeightForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Peso'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/consulta',
            name: 'list-consultation-pet',
            component: ConsultationList,
            meta: {
                requiresAuth: true,
                label: 'Consultas'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/consulta/novo',
            name: 'new-consultation-pet',
            component: ConsultationForm,
            meta: {
                requiresAuth: true,
                label: 'Nova Consulta'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/consulta/:idConsultation',
            name: 'edit-consultation-pet',
            component: ConsultationForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Consulta'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/medicamento',
            name: 'list-medicine-pet',
            component: MedicineList,
            meta: {
                requiresAuth: true,
                label: 'Medicamentos'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/medicamento/novo',
            name: 'new-medicine-pet',
            component: MedicineForm,
            meta: {
                requiresAuth: true,
                label: 'Nova Medicamento'
            }
        },
        {
            path: 'clientes/:idCliente/pets/:id/medicamento/:idMedicine',
            name: 'edit-medicine-pet',
            component: MedicineForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Medicamento'
            }
        }

    ]
}



// WEBPACK FOOTER //
// ./src/views/pets/router.js